// 聊天初始化服务钩子函数

import { useState, useEffect } from "react";
import type { Message } from "@/types/chat";

export interface UseChatInitializerReturn {
  chatId: string;
  initialMessages: Message[];
  setChatId: (id: string) => void;
  setInitialMessages: (messages: Message[]) => void;
  resetChat: () => void;
}

export function useChatInitializer(): UseChatInitializerReturn {
  const [chatId, setChatId] = useState<string>("default-chat");
  const [initialMessages, setInitialMessages] = useState<Message[]>([]);
  useEffect(() => {
    const storedChatId = window.location.pathname.split("/").pop() || "default-chat";
    setChatId(storedChatId);
  }, []);
  const resetChat = () => {
    setChatId("default-chat");
    setInitialMessages([]);
    window.history.replaceState({}, "", "/");
  };

  return {
    chatId,
    initialMessages,
    setChatId,
    setInitialMessages,
    resetChat,
  };
}